export default class CurrencyUtility {
  static format(amount: any): string|null {
    if (amount === null || typeof amount === 'undefined') {
      return null;
    }
    if (typeof amount === 'string' || amount instanceof String) {
      return Number.parseFloat(amount.valueOf()).toLocaleString();
    }
    return amount.toLocaleString();
  }

  static parse(amount: any): number|null {
    if (amount === null || typeof amount === 'undefined') {
      return null;
    }
    if (typeof amount === 'string' || amount instanceof String) {
      return Number.parseFloat(amount.replace(',', ''));
    }
    return amount;
  }
}
